module.exports = __webpack_public_path__ + "static/media/dog_avatar.69921708.svg";